<template>
  <div class="row">
    <a-table :dataSource="repasses" :columns="columnsRepasse">
      <template #paciente="{ record }">
        <span>{{ record.paciente.nome }}</span>
      </template>
      <template #profissionalRemetente="{ record }">
        <span>{{ record.profissionalRemetente.nome }}</span>
      </template>
      <template #profissionalDestinatario="{ record }">
        <span>{{ record.profissionalDestinatario.nome }}</span>
      </template>
      <!--
            <template #dataAtendimento="{record}">
                {{returnaDataFormatada(record.registroAtendimento.agendamentoMedico)}}
            </template>
           -->
      <template #idTermoAceite="{ record }">
        <a-tooltip title="Download do Termo" placement="top">
          <i class="fa-solid fa-file-arrow-down icon-download" style="margin-left: 44%; cursor: pointer" @click="baixarArquivo(record)"></i>
        </a-tooltip>
      </template>
      <template #dataEnvio="{ record }">
        {{ dataFormatada(record.dataEnvio) }}
      </template>
      <template #dataResposta="{ record }">
        {{ dataFormatada(record.dataResposta) }}
      </template>
      <template #action="{ record }">
        <div v-if="record.situacaoRepasse === 'SOLICITADO'">
          <a-tooltip title="Aceitar o Atendimento" placement="top">
            <i class="fa-solid fa-square-check icon-atend" style="color: #2bec96" @click="responderRepasse(record, 'ACEITO')"></i>
          </a-tooltip>
          <a-tooltip title="Recusar Atendimento" placement="top">
            <i class="fa-solid fa-rectangle-xmark icon-atend" style="color: #ba1a31" @click="responderRepasse(record, 'RECUSADO')"></i>
          </a-tooltip>
        </div>
        <div v-if="record.situacaoRepasse !== 'SOLICITADO'">
          {{ record.situacaoRepasse }}
        </div>
      </template>
    </a-table>
  </div>
</template>

<script>
import { getRepasseByCpfProf, responderRepasse } from '@/components/service/RepasseAtendimento';
import { getDataUser } from '@/utils';
import { formatarData } from '@/utils/servicos-utils';
import { downloadDocumentFileWs } from '@/utils/filews';

export default {
  name: 'PageRepasseAtendimentoPaciente',
  data() {
    return {
      dataUser: getDataUser(),
      repasses: [],
      columnsRepasse: [
        {
          title: 'Paciente',
          dataIndex: 'paciente',
          key: 'paciente',
          slots: { customRender: 'paciente' },
        },
        {
          title: 'De',
          dataIndex: 'profissionalRemetente',
          key: 'profissionalRemetente',
          slots: { customRender: 'profissionalRemetente' },
        },
        {
          title: 'Para',
          dataIndex: 'profissionalDestinatario',
          key: 'profissionalDestinatario',
          slots: { customRender: 'profissionalDestinatario' },
        },
        {
          title: 'Termo de Aceite',
          dataIndex: 'idTermoAceite',
          key: 'idTermoAceite',
          slots: { customRender: 'idTermoAceite' },
        },
        {
          title: 'Data Envio',
          dataIndex: 'dataEnvio',
          key: 'dataEnvio',
          slots: { customRender: 'dataEnvio' },
        },
        {
          title: 'Data Resposta',
          dataIndex: 'dataResposta',
          key: 'dataResposta',
          slots: { customRender: 'dataResposta' },
        },
        {
          title: 'Ação',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  async created() {
    await this.getMyRepasses();
  },
  methods: {
    async getMyRepasses() {
      await getRepasseByCpfProf(this.dataUser.cpf).then((r) => {
        this.repasses = r.data.reverse();
      });
    },
    returnaDataFormatada(obj) {
      let data = formatarData(new Date(obj.dataHoraInicio), 'DD/MM/YYYY');
      let horaInicio = formatarData(new Date(obj.dataHoraInicio), 'HH:mm');
      let horaFim = formatarData(new Date(obj.dataHoraFim), 'HH:mm');

      return data + ' ' + horaInicio + ' ás ' + horaFim;
    },
    dataFormatada(obj) {
      if (obj) {
        return formatarData(new Date(obj), 'DD/MM/YYYY HH:mm');
      } else {
        return '';
      }
    },
    async responderRepasse(repasse, resposta) {
      repasse.situacaoRepasse = resposta;
      await responderRepasse(repasse).then(async () => {
        await this.getMyRepasses();
      });
    },
    async baixarArquivo(record) {
      await downloadDocumentFileWs(record.idTermoAceite, record.nomeArquivo);
    },
  },
};
</script>

<style scoped>
.icon-atend {
  margin-right: 5px;
  font-size: 25px;
  cursor: pointer;
}

.upload-archive {
  font-size: 25px;
  margin-top: 30px;
}
</style>
